import React, { useState, useEffect } from 'react';
import { WebTabContainer, WebTabElements, GetMyloApp } from './styled';

const WebTab = ({ onTabChange }) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const savedTab = sessionStorage.getItem('selectedBottomTab');
    if (savedTab) {
      setSelectedTab(savedTab);
      onTabChange(savedTab);
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsVisible(currentScrollY < lastScrollY || currentScrollY < 0);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const tabItems = [
    {
      id: '1',
      name: 'HOME',
      icon: 'https://images.myloapp.in/NestJsUploads/1741781102951-home-unfilled.svg',
      activeIcon:
        'https://images.myloapp.in/NestJsUploads/1741782563471-home-filled.svg',
    },
    {
      id: '2',
      name: 'CATEGORIES',
      icon: 'https://images.myloapp.in/NestJsUploads/1741781177683-categories-unfilled.svg',
      activeIcon:
        'https://images.myloapp.in/NestJsUploads/1741783535237-categories-filled.svg',
    },
    {
      id: '3',
      name: 'COMMUNITY',
      icon: 'https://images.myloapp.in/NestJsUploads/1722851855904-community-unfilled.webp',
      activeIcon:
        'https://images.myloapp.in/NestJsUploads/1722850467857-community-filled.webp',
    },
    {
      id: '4',
      name: 'MY ACCOUNT',
      icon: 'https://images.myloapp.in/NestJsUploads/1741781221537-Profile-unfilled.svg',
      activeIcon:
        'https://images.myloapp.in/NestJsUploads/1741783576154-profile-filled.svg',
    },
  ];

  const handleTabClick = (id) => {
    setSelectedTab(id);
    onTabChange(id);
    sessionStorage.setItem('selectedBottomTab', id);
  };

  return (
    <WebTabContainer
      style={{
        transform: `translateY(${isVisible ? '0' : '100%'})`,
        transition: 'transform 0.3s ease-in-out',
      }}
    >
      <div className="webTabOptions">
        {tabItems.map((item, index) => (
          <WebTabElements
            key={index}
            onClick={() => {
              handleTabClick(item.id);
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }}
            isSelected={selectedTab === item.id}
          >
            <img
              src={
                selectedTab === item.id && item.activeIcon
                  ? item.activeIcon
                  : item.icon
              }
              alt={item.name}
              width="30px"
              height="30px"
            ></img>
            <p>{item.name}</p>
            <div
              className="GetMyloApp"
              onClick={() =>
                (window.location.href =
                  'https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web')
              }
            >
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: '15%',
                  margin: '2px 0',
                }}
              >
                <img
                  src="https://images.myloapp.in/NestJsUploads/1682404377508-myloLogo.svg"
                  alt="home"
                  width="20px"
                  height="14px"
                ></img>
              </div>
              <p>GET MYLO</p>
            </div>
          </WebTabElements>
        ))}
      </div>
    </WebTabContainer>
  );
};

export default WebTab;
